
const INVITE_CODE_KEY = 'invite_code'
const INVITE_TOKEN_KEY = 'invite_token'
const EMAIL_KEY = 'email'

interface InviteFlowParams {
  inviteToken?: string
  inviteCode?: string
  email?: string
}

/**
 * Reads invite-related query params from the current URL and persists them
 * to localStorage so they survive SSO redirects (Cognito round-trip).
 * Supports both the new `invite_token` flow and the legacy `invite_code`.
 */
export const saveInviteFlowParams = () => {
  const urlParams = new URLSearchParams(window.location.search)
  const inviteToken = urlParams.get(INVITE_TOKEN_KEY)
  const inviteCode = urlParams.get(INVITE_CODE_KEY)
  const email = urlParams.get(EMAIL_KEY)

  if (inviteToken) {
    localStorage.setItem(INVITE_TOKEN_KEY, inviteToken)
    if (email) localStorage.setItem(EMAIL_KEY, email)
  } else if (inviteCode && email) {
    localStorage.setItem(INVITE_CODE_KEY, inviteCode)
    localStorage.setItem(EMAIL_KEY, email)
  }
}

/**
 * Reads saved invite params from localStorage without removing them.
 * Params survive until explicitly cleared via `clearInviteFlowParams`.
 * Returns null when nothing is stored.
 */
export const getInviteFlowParams = (): InviteFlowParams | null => {
  const inviteToken = localStorage.getItem(INVITE_TOKEN_KEY)
  const inviteCode = localStorage.getItem(INVITE_CODE_KEY)
  const email = localStorage.getItem(EMAIL_KEY)

  if (inviteToken) return { inviteToken, email: email ?? undefined }
  if (inviteCode && email) return { inviteCode, email }
  return null
}

/**
 * Removes saved invite params from localStorage.
 * Call only after the params have been successfully consumed (e.g. getMe succeeded).
 */
export const clearInviteFlowParams = () => {
  localStorage.removeItem(INVITE_TOKEN_KEY)
  localStorage.removeItem(INVITE_CODE_KEY)
  localStorage.removeItem(EMAIL_KEY)
}
